<template>
    <div>
        <section id="header-checkout">
            <div class="main-bar">
                <div class="wrapper">
                    <div class="goBack">
                        <button class="back" @click.prevent="$router.go(-1)"><span>Powrót</span></button>
                    </div>
                    <div class="logo">
                        <router-link :to="'/home'">
                            <img src="@/assets/images/logo.svg" alt="Fluidra Polska" />
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
        <section id="content-page">
            <div class="wrapper global-content-config">
                <h1>Regulamin Katalogu online Fluidra Polska sp. z o.o.</h1>
                <h2>I. DEFINICJE</h2>
                <ol>
                    <li>Sprzedawca – Fluidra Polska sp. z o.o.., ul. Armii Krajowej 61, 50-541 Wrocław, KRS: 0000158890,
                        NIP: 8992466785.</li>
                    <li>Kupujący – przedsiębiorca współpracujący ze Sprzedawcą na podstawie zawartej Umowy Handlowej.
                    </li>
                    <li>Katalog Online – strona internetowa prowadzona przez Sprzedawcę, w celu usprawnienia procesu
                        sprzedaży.</li>
                    <li>Zamówienie – zapytanie dotyczące dostępności określonej ilości Towarów w określonej cenie ,
                        złożone przez Kupującego Sprzedawcy za pośrednictwem Katalogu Online j;</li>
                    <li>Towar – określone produkty dostępne w Katalogu Online zdjęcia produktów dostępne w Katalogu
                        Online są poglądowe i nie mogą być powodem reklamacji z powodu niezgodności towaru z umową.</li>
                    <li>Umowa Sprzedaży – umowa zawierana w momencie potwierdzenia Zamówienia przez Sprzedawcę,
                        określająca w szczególności nazwę Towaru i jego opis (specyfikacja) wraz z wymaganą
                        dokumentacją, ilość, cenę , termin dostawy i termin płatności. Do Umowy Sprzedaży zastosowanie
                        mają Ogólne Warunki Sprzedaży dostępne pod adresem …………………………..</li>
                </ol>
                <h2>II. SKŁADANIE ZAMÓWIEŃ</h2>
                <ol>
                    <li>Złożenia Zamówienia przez Kupującego następuje poprzez wykonanie następujących kroków:
                        <ol>
                            <li>zalogowanie się do katalogu Online, login stanowił będzie NIP Kupującego, hasło zostanie
                                przesłane przez Sprzedawcę.</li>
                            <li>złożenie oświadczenia o zapoznaniu się i zaakceptowaniu Regulaminu, poprzez zaznaczenie
                                pola.</li>
                            <li>wybór Towaru i jego ilości.</li>
                            <li>kliknięcie pola: „Zamawiam” .</li>
                        </ol>
                    </li>
                    <li>Po złożeniu Zamówienia, na adres e-mail wskazany przez Kupującego przesyłane jest potwierdzenie
                        otrzymania zamówienia przez Sprzedawcę.</li>
                    <li>Sprzedawca zobowiązuje się skontaktować z Kupującym w terminie trzech dni roboczych w celu
                        zawarcia Umowy Sprzedaży. Do zawarcie umowy sprzedaży dochodzi w momencie potwierdzenia przez
                        Sprzedawcę zamówienia, które zostaje wysłane na adres mailowy Kupującego.</li>
                    <li>Ostateczna cena Towaru na fakturze w PLN określona będzie na podstawie kursu EURO z dnia
                        sprzedaży, wiec może się różnić od ceny podanej w Katalogu Online.</li>
                    <li>W przypadku braku albo odmowy potwierdzenia Zamówienia przez Sprzedawcę, do zawarcia umowy
                        sprzedaży nie dochodzi, co nie będzie stanowić podstawy do roszczeń pomiędzy Stronami.</li>
                    <li>Ceny Towarów w Katalogu Online mają charakter informacyjny i nie stanową oferty w rozumieniu
                        art. 66 KC. Sprzedawca ma prawo do zmiany cen w każdym czasie.</li>
                </ol>
                <h2>III. POSTANOWIENIA KOŃCOWE</h2>
                <p>Sprzedawca zastrzega sobie prawo do modyfikacji Regulaminu w każdym czasie, jednak modyfikacja nie ma
                    zastosowania do Zamówień złożonych przed datą modyfikacji lub Umów Rezerwacji zawartych przed tą
                    datą. Do konkretnych Zamówień i Umów Rezerwacyjnych zastosowanie mają postanowienia Regulaminu
                    obowiązujące w dniu złożenia Zamówienia przez Kupującego.</p>
            </div>
        </section>
    </div>
</template>
<script>

export default {
    name: 'Regulamin'
}
</script>
<style scoped></style>